/**
 * Find the maximum depth of the tree
 * @param {TreeRecord} tree
 */
const getTreeDepth = (tree, depth = 0) => {
  // returns depth if no children, or the maximum depth of
  // a child
  return tree.children.reduce((value, node) => {
    return Math.max(value, getTreeDepth(node, depth + 1));
  }, depth);
};

export default getTreeDepth;
